import { Divider, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";

const Password = () => {
  const { t: translate } = useTranslation(["setting"]);
  return (
    <Box>
      <Typography variant="subtitle1">{translate("PasswordReset")}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.8, pb: 2 }}>
        {translate("Updateyourpassword")}
      </Typography>
      <Divider />
      <Box sx={{ mt: 3 }}>
        <Box sx={{ my: 2 }}>
          <TextField
            label={translate("oldpassword")}
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            defaultValue={"124bkf#4Ef"}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <TextField
            label={translate("NewPassword")}
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            defaultValue={"124bkf#4Ef"}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <TextField
            label={translate("Confirmpassword")}
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            defaultValue={"124bkf#4Ef"}
          />
        </Box>
        <Box sx={{ mt: 4 }}>
          <button
            type="submit"
            class=" py-3 px-6 tracking-wider text-sm rounded-md text-white bg-[#4D772D] hover:bg-[#204207] focus:outline-none"
          >
            {translate("upDatePassword")}
          </button>
        </Box>
      </Box>
    </Box>
  );
};

export default Password;
